import { Navigate, useLocation } from 'react-router-dom';
import { useLearnPortal } from '@/contexts/LearnPortalContext';

interface LearnProtectedRouteProps {
  children: React.ReactNode;
}

export const LearnProtectedRoute: React.FC<LearnProtectedRouteProps> = ({ children }) => {
  const { session, isLoading } = useLearnPortal();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!session?.isValid) {
    return <Navigate to="/learn/auth" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
